import { render, staticRenderFns } from "./SalesOrderViewDetailsSalesOrderItemTableV2.vue?vue&type=template&id=0355f4e1"
import script from "./SalesOrderViewDetailsSalesOrderItemTableV2.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewDetailsSalesOrderItemTableV2.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderViewDetailsSalesOrderItemTableV2.vue?vue&type=style&index=0&id=0355f4e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports